import { Card } from "ui/components/card";

export default function ChartLoader() {
  return (
    <Card className="mx-6 mt-4">
      <div className=" flex gap-4 px-6 items-end mx-auto grid grid-cols-1 md:grid-cols-3 ">
        <div className="h-[100px] w-20 bg-muted animate-pulse rounded-lg" />
        <div className="h-[300px] w-20 bg-muted animate-pulse rounded-lg" />
        <div className="h-[200px] w-20 bg-muted animate-pulse rounded-lg" />
      </div>
    </Card>
  );
}
